import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card } from "antd";
import { ReactComponent as SmasiPictureMark } from "./Assets/smartsignals_Picturemark.svg";
import { Row, Col } from "antd/lib";
const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw")
    ? "vw"
    : "cm";

const SignInPage = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async () => {
    console.log("Login button clicked");
    await oktaAuth.signInWithRedirect();
  };

  React.useEffect(() => {
    document.title = `QA Auditor | Login`;
  }, []);

  React.useEffect(() => {
    if (authState?.isAuthenticated) {
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    }
  }, [authState, navigate, location]);

  if (authState?.isAuthenticated) {
    return <p>Redirecting...</p>;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <Card style={{ width: 400, textAlign: "center" }}>
        <Row align="middle">
          <Col flex="auto" style={{ alignItems: "start" }}>
            <SmasiPictureMark
              width={"38px"}
              style={{
                marginTop: "12px",
              }}
            />
            <h1 style={{ fontFamily: `${client}Bold`, fontSize: "1.75rem" }}>
              Smart QA Auditor.
            </h1>
          </Col>
        </Row>

        <Button
          type="primary"
          onClick={handleLogin}
          block
          style={{
            fontFamily: `${client}Regular`,
            marginTop: "2rem",
            fontSize: "1rem",
            width: "16rem",
            height: "2.6rem",
            background: "#2045C0",
            color: "#FFFFFF",
          }}
        >
          Login
        </Button>
      </Card>
    </div>
  );
};

export default SignInPage;
